export default __webpack_public_path__ + "static/media/circle-step-inprogress.10e740cc.svg";